import React from "react";
import { SRLWrapper } from "simple-react-lightbox";
import img1 from "../../assets/kamron_smile.jpg";
import img2 from "../../assets/image_kam.jpg";
import img3 from "../../assets/firths_kam.jpg";
import img4 from "../../assets/teachers.jpg";
// import img5 from "../../assets/sher1.jpg";
// import img6 from "../../assets/sherF.jpg";
// import img7 from "../../assets/ielts.jpg";
import style from "../../pages/Project/MainSingleProject.module.css";
import { useTranslation } from "react-i18next";
import { AccessTime, LiveTv, People } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
export const KamronSingle = ({open}) => {
  const { t } = useTranslation();
  const map = [
    {
      id: 1,
      img: img1,
      title: "Pre -Intermediate",
      title2: "Pre -Intermediate English course",
      text: t("mirzakhanov.degre"),
      sum1: 2000000,
      sum2: 1500000,
      sum3: 200000,
      sum4: 150000,
    },
    {
      id: 2,
      img: img2,
      title: "Intermediate",
      title2: "Intermediate course",
      text: t("mirzakhanov.degre2"),
      sum1: 2000000,
      sum2: 1500000,
      sum3: 250000,
      sum4: 250000,
    },
    {
      id: 3,
      img: img3,
      title: "IELTS course",
      title2: "IELTS course",
      text: t("sher.number3"),
      sum1: 3000000,
      sum2: 2500000,
      sum3: 300000,
      sum4: 250000,
    },
  ];
  const click=()=>{
    open(false)
  }
  const map2 = map.map((a) => (
    <NavLink to="/lesson" onClick={click}>
      <div className={style.Sher} key={a.id}>
        <img src={a.img} alt="" />
        <div className={style.Course_Name}>
          <p>{a.title}</p>
          <h2>{a.title2}</h2>
          <div className={style.Sher_coursee}>
            <h3>
              <AccessTime style={{ fontSize: "16px" }} />
              Lifetime Access
            </h3>
            <h3>
              <LiveTv style={{ fontSize: "16px" }} /> 40 Lessons
            </h3>
            <h3>
              <People style={{ fontSize: "16px" }} /> 500 student
            </h3>
          </div>
          <h5>{a.text}</h5>
          <h6>
            {t("sher.education")}:
            <b>
              {" "}
              {a.sum1} {t("sher.maney")}{" "}
            </b>
            <span>
              {a.sum2} {t("sher.maney")}
            </span>{" "}
          </h6>
          <h6>
            {t("sher.education2")}:{" "}
            <b>
              {a.sum3}
              {t("sher.maney")}
            </b>
            <span>
              {a.sum4} {t("sher.maney")}
            </span>{" "}
          </h6>
        </div>
      </div>
    </NavLink>
  ));

  return (
    <div className={style.lavhalar}>
      <h1>{t("sher.about")}</h1>
      <p>{t("my_teacher.addition")} </p>
      <ul>
        <li>
          {t("sher.username")}: {t("my_teacher.name")}{" "}
        </li>
        <li>
          {t("age")}: 21{" "}
        </li>
        <li>
          {t("sher.result")} : <b style={{ color: "red" }}>7</b>{" "}
        </li>
        <li>
          {t("sher.experience")} : {t("my_teacher.experience")}
        </li>
        <li>
          {t("sher.experience")} : {t("my_teacher.experience1")}
        </li>
        <li>{t("sher.number")} : 450+</li>
        <li>{t("mirzakhanov.student")}</li>
      </ul>
      {map2}
      <div className={style.lavhalar1}>
        <SRLWrapper>
          <div>
            <a href={img1}>
              <img src={img1} alt="Loyiha1" />
            </a>
            <a href={img4}>
              <img src={img4} alt="Loyiha4" />
            </a>
            <a href={img2}>
              <img src={img2} alt="Loyiha2" />
            </a>
            <a href={img3}>
              <img src={img3} alt="Loyiha3" />
            </a>
           
          </div>
        </SRLWrapper>
      </div>
    </div>
  );
};
